export { default } from './ReCaptcha';



// WEBPACK FOOTER //
// ./src/components/Captcha/ReCaptcha/index.js